import { ServiceProviderService } from './../../../services/service-provider.service';
import { AdditionalFeaturesPopupComponent } from './../additional-features-popup/additional-features-popup.component';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { RoleType } from 'src/app/enum/role-type';
import { ExcelService } from 'src/app/services/excel.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { RoleService } from 'src/app/services/role.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import * as _ from "lodash";
import { MatDialog } from '@angular/material/dialog';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { forkJoin } from 'rxjs';
import swal from 'sweetalert2';


@Component({
    selector: 'app-manage-service-provider-edit',
    templateUrl: './manage-service-provider-edit.component.html',
    styleUrls: ['./manage-service-provider-edit.component.scss']
})
export class ManageServiceProviderEditComponent implements OnInit {
    roleTypeEnum = RoleType;
    sessionDataString: any;
    id: any;
    type: any;
    selectedIndex: number;
    form: FormGroup;
    slaForm: FormGroup;
    data = [];
    dataSource = new MatTableDataSource(this.data);
    displayedColumns: string[] = [
        "name",
        "mobileNumber",
        "email",
        "action"
    ];
    dataT = [];
    dataSourceT = new MatTableDataSource(this.data);
    displayedColumnsT: string[] = [
        "targetCount",
        "effectiveFrom"
    ];

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    servicequeue: any = [];
    slaList: any;
    serviceproviderdata: any;
    // @ViewChild(MatPaginator, { static: true }) paginatorT: MatPaginator;
    constructor(
        private lookupDataService: LookupDataServiceService,
        private navigationService: NavigationService,
        private matdialog: MatDialog,
        private serviceProviderDataService: ServiceProviderService,
        private toastr: NotificationService,
        private ServiceProviderService: ServiceProviderService,
        private activateroute: ActivatedRoute,
        private _formBuilder: FormBuilder,
        private sessionService: UserSessionService,

    ) {
        debugger
        this.activateroute.params.subscribe((params: any) => {
            this.id = parseInt(params.id);
            this.type = parseInt(params.type);
        });

    }

    ngOnInit() {
        this.sessionDataString = JSON.parse(
            localStorage.getItem(this.sessionService.localStorageSessionKey)
        );
        this.initForm();
        if (this.id > 0) {
            this.tableData();
        }
        this.getServiceProviderList()
        this.getSLAListById()
    }

    initForm() {
        this.form = this._formBuilder.group({
            providerName: ["", Validators.required],
            referenceName: [""]
        });
        this.slaForm = this._formBuilder.group({
            isApprovalState: [false],
            approvalStateTimeInterval: [null],
            isCompletedState: [false],
            completedStateTimeInterval: [null],
            isSPRequested: [false],
            spRequestedTimeInterval: [null],
            isSPConfrimed: [false],
            spConfrimedTimeInterval: [null],
            isDeviceAllocation: [false],
            deviceAllocationTimeInterval: [null],
            isDispatch: [false],
            dispatchTimeInterval: [null],
            isToBeBilled: [false],
            toBeBilledTimeInterval: [null],
        });

    }

    tableData() {
        this.ServiceProviderService.getrContactListbyId(this.id).subscribe(res => {
            this.data = [];
            var i = 1
            res.forEach((item: any) => {
                item.contactId = i;
                this.data.push(item);
                i++;
            });
            this.data = _.orderBy(res, ["id"]);
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.paginator = this.paginator;
        });

        this.ServiceProviderService.getTargetListById(this.id).subscribe(res => {
            this.dataT = [];
            this.dataT = res;
            this.dataSourceT = new MatTableDataSource(this.dataT);
            // this.dataSourceT.paginator = this.paginatorT;
        });
    }


    setNull(event, controllername) {
        if (!event.checked) {
            this.slaForm.controls[controllername].setValue(null);
        }
    }

    onTabChange(event: MatTabChangeEvent) {
        this.selectedIndex = event.index
    }

    goToManageService() {
        this.navigationService.goToManageService();
    }
    addSPContact() {
        const dialogref = this.matdialog.open(AdditionalFeaturesPopupComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'mat-dialog',
            // width: "550px",
            data: {
                title: 'Manage SPContacts'
            }
        });
        dialogref.afterClosed().subscribe(res => {
            debugger
            if (res && res.value) {
                debugger
                let contact = res.value
                var contactid = 0;
                var lastrecord = this.data.slice(-1)[0];
                if (lastrecord) {
                    debugger
                    contactid = lastrecord.contactId;
                    contactid++
                }
                else {
                    contactid++
                }
                contact.contactId = contactid;
                contact.isDelete = false;
                this.data.unshift(contact);
                this.dataSource = new MatTableDataSource(this.data);
                this.dataSource.paginator = this.paginator;
                // vm.serviceProvider.contactList = angular.copy(vm.serviceProvider.contactList);
            }
        })

    }
    addSPTarget() {
        const dialogref = this.matdialog.open(AdditionalFeaturesPopupComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'mat-dialog',
            // width: "550px",
            data: {
                title: 'Target'
            }
        });
        dialogref.afterClosed().subscribe(res => {
            if (res && res.value) {
                debugger
                let target = res.value
                this.dataT.unshift(
                    {
                        id: 0, serviceProviderId: this.id,
                        targetCount: target.targetCount, effectiveFrom: target.effectiveFrom
                    });
                this.dataSourceT = new MatTableDataSource(this.dataT);
                this.dataSourceT.paginator = this.paginator;
                console.log("datdadsas---", this.dataT);

            }
        })
    }
    getSLAListById() {
        this.ServiceProviderService.getSLAListById(this.id).subscribe(res => {
            this.slaList = res
            debugger
            this.slaForm.patchValue({
                isApprovalState: this.slaList[0].isApprovalState,
                approvalStateTimeInterval: this.slaList[0].approvalStateTimeInterval,
                isCompletedState: this.slaList[0].isCompletedState,
                completedStateTimeInterval: this.slaList[0].completedStateTimeInterval,
                isSPRequested: this.slaList[0].isSPRequested,
                spRequestedTimeInterval: this.slaList[0].spRequestedTimeInterval,
                isSPConfrimed: this.slaList[0].isSPConfrimed,
                spConfrimedTimeInterval: this.slaList[0].spConfrimedTimeInterval,
                isDeviceAllocation: this.slaList[0].isDeviceAllocation,
                deviceAllocationTimeInterval: this.slaList[0].deviceAllocationTimeInterval,
                isDispatch: this.slaList[0].isDispatch,
                dispatchTimeInterval: this.slaList[0].dispatchTimeInterval,
                isToBeBilled: this.slaList[0].isToBeBilled,
                toBeBilledTimeInterval: this.slaList[0].toBeBilledTimeInterval,
            });
        });
    }
    showEditSPContact(contact) {
        const dialogref = this.matdialog.open(AdditionalFeaturesPopupComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'mat-dialog',
            // width: "550px",
            data: {
                title: 'Manage SPContacts',
                value: contact
            }
        });
        dialogref.afterClosed().subscribe(res => {
            if (res && res.value) {
                debugger
                let contact = res.value
                // this.data[this.GetArrayIndexByPropertyvalue(this.data, "contactId", contact.contactId)] = contact;
                let index = this.data.findIndex(response => response.mobileNumber == contact.mobileNumber);
                if (index !== -1) {
                    this.data[index] = contact;
                }
                this.dataSource = new MatTableDataSource(this.data);
                this.dataSource.paginator = this.paginator;
            }

        })
    }

    GetArrayIndexByPropertyvalue(array, propertyName, propertyValue) {
        return array.map(function (e) {
            return e[propertyName];
        }).indexOf(propertyValue);
    }
    onsubmit() {
        // if (this.form.controls['providerName'].valid) {

        // }
        debugger
        var payload: any = {}
        payload = this.serviceproviderdata || {}
        payload.ServiceProviderContactMapping = [];
        if (this.slaForm.value.isApprovalState) {
            if (!this.slaForm.value.approvalStateTimeInterval) {
                this.toastr.showError("Fill Approval SLA Time");
                return;
            }
        }
        if (this.slaForm.value.isCompletedState) {
            if (!this.slaForm.value.completedStateTimeInterval) {
                this.toastr.showError("Fill Completed SLA Time");
                return;
            }
        }
        if (this.slaForm.value.isSPRequested) {
            if (!this.slaForm.value.spRequestedTimeInterval) {
                this.toastr.showError("Fill SP Requested SLA Time");
                return;
            }
        }
        if (this.slaForm.value.isSPConfrimed) {
            if (!this.slaForm.value.spConfrimedTimeInterval) {
                this.toastr.showError("Fill Sp Confrimed SLA Time");
                return;
            }
        }
        if (this.slaForm.value.isDeviceAllocation) {
            if (!this.slaForm.value.deviceAllocationTimeInterval) {
                this.toastr.showError("Fill Device Allocation SLA Time");
                return;
            }
        }
        if (this.slaForm.value.isDispatch) {
            if (!this.slaForm.value.dispatchTimeInterval) {
                this.toastr.showError("Fill Dispatch SLA Time");
                return;
            }
        }
        if (this.slaForm.value.isToBeBilled) {
            if (!this.slaForm.value.toBeBilledTimeInterval) {
                this.toastr.showError("Fill Completed To be Billed SLA Time");
                return;
            }
        }
        if (this.data.length > 0) {
            this.data.forEach(item=> {
                payload.ServiceProviderContactMapping.push({
                    ServiceProviderId: this.id, Contact: item
                })
            })
        }
        payload.contactList = this.data
        payload.targets = this.dataT
        payload.providerName = this.form.value.providerName
        payload.referenceName = this.form.value.referenceName

        this.slaList = [{ ...this.slaList[0], ...this.slaForm.value }];
        payload.sLA = (this.slaList)


        this.serviceProviderDataService.serviceProviderCommonSave(payload).subscribe((crudStatus) => {
            if (crudStatus == 1) {
                this.toastr.showSuccess("Data Added Successfully");
                this.navigationService.goToManageService();
            }
            else if (crudStatus == 3) {
                this.toastr.showSuccess("Data Updated Successfully");
                this.navigationService.goToManageService();
            }
        });
    }

    deleteContact(id, name, contactid) {
        const txt = 'Are you sure want to delete ' + name + ' ?';
        const Yes = 'Yes';
        const No = 'No';
        swal.fire({
            text: txt,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7D32DE',
            cancelButtonColor: '#23C00A',
            confirmButtonText: Yes,
            cancelButtonText: No,
        }).then((result) => {
            if (result.isConfirmed) {
                debugger
                if (id != 0 && id != undefined) {
                    let index = this.data.findIndex(x => x.id === id);

                    if (index !== -1) {
                        debugger
                        // Set isDelete to true
                        this.data[index].isDelete = true;
                        let newarray = [...this.data]

                        // Remove the object from the data array
                        newarray.splice(index, 1);
                        this.dataSource = new MatTableDataSource(newarray);
                        this.dataSource.paginator = this.paginator;
                    }
                }
                else {
                    debugger
                    var deletedIndex = this.GetArrayIndexByPropertyvalue(this.data, "contactId", contactid);
                    this.data.splice(deletedIndex, 1);
                    this.dataSource = new MatTableDataSource(this.data);
                    this.dataSource.paginator = this.paginator;
                }

            }
        });
    }
    getServiceProviderList() {
        this.serviceProviderDataService.getServiceProviderbyId(this.id).subscribe(res => {
            this.serviceproviderdata = res
            this.form.patchValue(
                { providerName: res.providerName, referenceName: res.referenceName }
            )
        })

    }

}
